import useAjax from "@hooks/use-ajax.hook";
import useDataStore from "@state/DataStore";
import { useCallback } from "react";
import { ConfigurationType } from "./types";

const useConfiguration = () => {
  const configuration = useDataStore((state) => state.configuration);
  const { request, error, loading, clearError } = useAjax();

  const fetchConfiguration = useCallback(async () => {
    const data = await request<string>("get_configuration");
    if (data != null) {
      const parsed = JSON.parse(data) as ConfigurationType;
      useDataStore.getState().setConfiguration(parsed);
      return parsed;
    }
    return data;
  }, [request]);

  return {
    fetchConfiguration,
    configuration,
    loading,
    error,
    clearError,
  };
};

export default useConfiguration;
